export default __webpack_public_path__ + "static/media/ICON1.69f0efc5.svg";